export const API_URLS = {
  IP_URL: 'https://api.ipify.org/?format=json',
}
